import { IndorImages, getIndorImageSrc } from "../../../../features"
import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import { setCameraInfoWindowIsShown } from "../../../../stateManagement/reducers/RoadWebCameraSlice"
import { store } from "../../../../stateManagement/store"
import { ContentHeaderButton } from "../../contentHeaderButton"

const cameraInfoWindowButtonIconSrc = getIndorImageSrc(IndorImages.MessageInfo);

export default function ContentHeaderRoadWebCameraWidgets() {

    const cameraInfoWindowIsShown = useAppSelector(state => state.roadWebCamera.cameraInfoWindowIsShown)

    function controlCameraInfoWindowButton() {
        const cameraInfoWindowIsShown = store.getState().roadWebCamera.cameraInfoWindowIsShown
        store.dispatch(setCameraInfoWindowIsShown(!cameraInfoWindowIsShown))
    }

    const widgetsConfigArray = [
        {
            active: cameraInfoWindowIsShown,
            name: "Информация о камере",
            imageSrc: cameraInfoWindowButtonIconSrc,
            onClick: controlCameraInfoWindowButton
        }
    ]

    return (
        <>
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            key={name}
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                        />
                    )
                }
            })}
        </>
    )
}